import { axiosGet } from 'shared/api/axios'
import { apiUrls } from 'consts'
import { formatDateTime, stringToDateTime } from 'utils/dateUtils'

interface getRowsProps {
  id: string
  filterId: string
}

const getRows = async (props: getRowsProps) => {
  const getParams = {
    id: props.id,
    filterId: props.filterId
  }

  const response = await axiosGet(apiUrls.filterSyncLogDetails, getParams)

  const data = response.data

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].created_at = formatDateTime(stringToDateTime(dataArray[index].created_at))
  })

  return data
}

export default getRows
